import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../../auth/auth.guard';
import { MasterResolver } from '../master/master.resolver';

import { CouplingsComponent } from './couplings.component';
import { BusinessGuard } from 'src/app/auth/business.guard';

const routes: Routes = [
  {
    path: ':business',
    data: { breadcrumb: 'business' },

    children: [
      {
        path: 'couplings',
        component: CouplingsComponent,
        canActivate: [AuthGuard, BusinessGuard],
        resolve: [MasterResolver],
        data: { breadcrumb: 'Acoplamientos' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CouplingsRoutingModule {}
